var ReifendirektQuickOrderAddOnJs = (function ($) {

    var init = function (submitBtnSel, formSel) {
        $(document).on('click', submitBtnSel, function () {
            $(".required-error").hide();
            $(".loader-enabled").show();
            $(".j-quickOrderSubmit").attr("disabled","disabled");

            if (ReifendirektCaptchaAddOnJs.isInvisibleCaptchaEnabled()) {
                ReifendirektCaptchaAddOnJs.executeRecaptcha('quickOrder_recaptcha');
            } else{
               submitQuickOrderForm(submitBtnSel, formSel);
            }

            return false;
        });
    };
    var submitQuickOrderForm = function (submitBtnSel, formSel) {
         MainJS.ajaxCall($(formSel).attr('action'), $(formSel).attr('method'), $(formSel).serialize(), function(data) {
             var $data = $(data);
             $(formSel).parent().html($data);
         }, null, {});
    };
    var submitQuickOrder = function () {
        submitQuickOrderForm('.j-quickOrderSubmit', '.j-quickOrder-form');
    }
    return {
        init : init,
        submitQuickOrder:submitQuickOrder
    };

})(jQuery);

$(document).ready(function() {
    ReifendirektQuickOrderAddOnJs.init('.j-quickOrderSubmit', '.j-quickOrder-form');
});
